export default function Template(props) {
    return <div className="NotificationTitle">Видалено всі повідомлення</div>
}
